// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__872bT","closeWrapper":"Auth_closeWrapper__28oeh","closeIcon":"Auth_closeIcon__0b-se"};